import React, { useState, useEffect } from 'react';
import { getBlogComments, createBlogComment } from '../../utils/api';
import './BlogComments.css';

const BlogComments = ({ blogId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState({
    name: '',
    email: '',
    comment: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (blogId) {
      fetchComments();
    }
  }, [blogId]);

  const fetchComments = async () => {
    try {
      setLoading(true);
      const data = await getBlogComments(blogId);
      setComments(data);
      setLoading(false);
    } catch (error) {
      console.error('Yorumlar yüklenirken hata:', error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewComment(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newComment.name || !newComment.email || !newComment.comment) {
      alert('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      setSubmitting(true);
      await createBlogComment(blogId, newComment);
      setNewComment({ name: '', email: '', comment: '' });
      fetchComments(); // Yorumları yenile
      alert('Yorumunuz başarıyla eklendi!');
    } catch (error) {
      console.error('Yorum gönderirken hata:', error);
      alert('Yorum gönderirken bir hata oluştu.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="comments-loading">
        <div className="loading-spinner"></div>
        <p>Yorumlar yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="blog-comments">
      <h3>Yorumlar ({comments.length})</h3>
      
      {/* Yorumlar Listesi */}
      <div className="comments-list">
        {comments.length === 0 ? (
          <div className="no-comments">
            <p>Henüz yorum yapılmamış. İlk yorumu siz yapın!</p>
          </div>
        ) : (
          comments.map((comment) => (
            <div key={comment.id} className="comment-item">
              <div className="comment-header">
                <div className="comment-author">
                  <strong>{comment.name}</strong>
                </div>
                <div className="comment-date">
                  {new Date(comment.created_at).toLocaleDateString('tr-TR')}
                </div>
              </div>
              <div className="comment-content">
                {comment.comment}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Yorum Formu */}
      <div className="comment-form-container">
        <h4>Yorum Yap</h4>
        <form onSubmit={handleSubmit} className="comment-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Ad Soyad *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={newComment.name}
                onChange={handleInputChange}
                required
                placeholder="Adınız ve soyadınız"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-posta *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={newComment.email}
                onChange={handleInputChange}
                required
                placeholder="E-posta adresiniz"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="comment">Yorumunuz *</label>
            <textarea
              id="comment"
              name="comment"
              value={newComment.comment}
              onChange={handleInputChange}
              required
              rows="5"
              placeholder="Yorumunuzu buraya yazın..."
            />
          </div>
          <button 
            type="submit" 
            className="submit-comment-btn"
            disabled={submitting}
          >
            {submitting ? 'Gönderiliyor...' : 'Yorum Gönder'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlogComments; 